export const getBackups = state => state.entries.backup

export const getDeviceBackups = (state, deviceId) => getBackups(state)[deviceId]

export const getDeviceBackupById = (state, deviceId, backupId) =>
  getBackups(state)[deviceId]?.find(({ id }) => id === backupId)
